<template>
	<div>
		<b-form>
			<b-row class="mt-4">
				<b-col xl="3" lg="3" sm="3">
					<p class="mt-3">
						<span class="h3">Product</span>
					</p>
				</b-col>
				<b-col xl="9" lg="9" sm="9">
					<b-form-group label-for="input-1">
						<!-- <b-form-input id="input-1" :state="productStatus" v-model="nsimRulesForm.product"></b-form-input> -->
						<b-form-select
							id="eprl"
							:state="productStatus"
							v-model="nsimRulesForm.product"
							:options="productlist"
						></b-form-select>
					</b-form-group>
					<b-form-invalid-feedback :state="productStatus">
						Please enter a valid Product.
					</b-form-invalid-feedback>
				</b-col>
			</b-row>
			<b-row>
				<b-col xl="3" lg="3" sm="3">
					<p class="mt-3">
						<span class="h3">Metric</span>
					</p>
				</b-col>
				<b-col xl="9" lg="9" sm="9">
					<b-form-group label-for="input-1">
						<b-form-input
							id="input-1"
							:state="metricStatus"
							type="number"
							v-model="nsimRulesForm.metric"
						></b-form-input>
						<b-form-invalid-feedback :state="metricStatus">
							Please enter a valid Metric.
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col xl="3" lg="3" sm="3">
					<p class="mt-3">
						<span class="h3">Tadig</span>
					</p>
				</b-col>
				<b-col xl="9" lg="9" sm="9">
					<b-form-group label-for="input-1">
						<!-- <b-form-input
                id="input-1"
                :state="tadigStatus"
                v-model="nsimRulesForm.tadig"
            ></b-form-input> -->
						<b-form-select
							id="eprl"
							:state="tadigStatus"
							v-model="nsimRulesForm.tadig"
							:options="tadiglist"
						></b-form-select>
						<b-form-invalid-feedback :state="tadigStatus">
							Please select a valid Tadig.
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col xl="3" lg="3" sm="3">
					<p class="mt-3">
						<span class="h3">Action</span>
					</p>
				</b-col>
				<b-col xl="9" lg="9" sm="9">
					<b-form-group label-for="input-1">
						<!-- <b-form-input
                id="input-1"
                :state="actionStatus"
                v-model="nsimRulesForm.action"
            ></b-form-input> -->
						<b-form-select
							id="eprl"
							:state="actionStatus"
							v-model="nsimRulesForm.action"
							:options="actionlist"
						></b-form-select>
						<b-form-invalid-feedback :state="actionStatus">
							Please select a valid Action.
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col xl="3" lg="3" sm="3">
					<p class="mt-3">
						<span class="h3">Name</span>
					</p>
				</b-col>
				<b-col xl="9" lg="9" sm="9">
					<b-form-group label-for="input-1">
						<b-form-input id="input-1" :state="nameStatus" v-model="nsimRulesForm.name"></b-form-input>
						<b-form-invalid-feedback :state="nameStatus">
							Please enter a valid name.
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col xl="3" lg="3" sm="3">
					<p class="mt-3">
						<span class="h3">Location</span>
					</p>
				</b-col>
				<b-col xl="9" lg="9" sm="9">
					<b-form-group label-for="input-1">
						<b-form-select
							id="select-1"
							:state="locationStatus"
							v-model="nsimRulesForm.location"
							:options="locationList"
						></b-form-select>
						<b-form-invalid-feedback :state="locationStatus">
							Please enter a valid location.
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<hr />
			<div class="mt-3 d-flex justify-content-between">
				<base-button type="white" title="Close" v-on:click="modalClose()"> Close </base-button>
				<base-button
					v-if="!update"
					type="primary"
					title="Save"
					v-on:click="saveSubmit"
					:loading="submitLoading"
					:disabled="
						!(productStatus && metricStatus && nameStatus && locationStatus && tadigStatus && actionStatus)
					"
				>
					Save
				</base-button>
				<base-button
					v-if="update"
					type="primary"
					title="Save"
					v-on:click="saveUpdateSubmit"
					:loading="submitLoading"
				>
					Save
				</base-button>
			</div>
		</b-form>
	</div>
</template>

<script>
import {VueTelInput} from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import handleResponse from "../../../../common/directive/handlResponse";
import productManagementService from "../../../../common/api-services/product-management-service";

export default {
	name: "NsimRules-From",
	props: ["update"],
	components: {
		VueTelInput,
	},
	computed: {
		productStatus() {
			return this.nsimRulesForm.product != "";
		},
		metricStatus() {
			return this.nsimRulesForm.metric.length > 0;
		},
		nameStatus() {
			return this.nsimRulesForm.name.length > 0;
		},
		locationStatus() {
			return this.nsimRulesForm.location.length > 0;
		},
		tadigStatus() {
			return this.nsimRulesForm.tadig != "";
		},
		actionStatus() {
			return this.nsimRulesForm.action != "";
		},
	},
	data() {
		return {
			metric: 0,
			nsimRulesForm: {
				id: "",
				product: "",
				metric: "",
				name: "",
				location: "",
				tadig: "",
				action: "",
			},
			submitLoading: false,
			locationList: [],
			productlist: [],
			tadiglist: [],
			actionlist: [
				{value: "allow", text: "allow"},
				{value: "deny", text: "deny"},
			],
		};
	},
	mounted() {
		this.getProductList();
		this.getTadigList();
		this.getLocationList();
		this.$root.$on("ChangeNsimRulesOldData", res => {
			this.nsimRulesForm.id = res.id;
			this.nsimRulesForm.product = res.product;
			this.nsimRulesForm.name = res.name;
			this.nsimRulesForm.metric = res.metric;
			this.nsimRulesForm.tadig = res.tadig;
			this.nsimRulesForm.action = res.actionData;
			this.nsimRulesForm.location = res.location;
		});
	},
	methods: {
		modalClose() {
			this.$bvModal.hide("add-nsim-rules");
			this.$bvModal.hide("edit-nsim-rules");
		},

		async saveSubmit() {
			if (
				this.nsimRulesForm.product != "" &&
				this.nsimRulesForm.name != "" &&
				this.nsimRulesForm.metric != "" &&
				this.nsimRulesForm.tadig != "" &&
				this.nsimRulesForm.action != ""
			) {
				this.submitLoading = true;

				const save = await productManagementService.addNsimRules(this.nsimRulesForm);

				this.modalClose();
				this.$root.$emit("getNsimRulesListFunc");
			} else {
				this.$root.$emit("danger", "Please input valid data");
			}
		},

		async saveUpdateSubmit() {
			if (
				this.nsimRulesForm.id != "" &&
				this.nsimRulesForm.product != "" &&
				this.nsimRulesForm.name != "" &&
				this.nsimRulesForm.metric != "" &&
				this.nsimRulesForm.tadig != "" &&
				this.nsimRulesForm.action != ""
			) {
				this.submitLoading = true;

				const save = await productManagementService.updateNsimRules(this.nsimRulesForm);

				this.modalClose();
				this.$root.$emit("getNsimRulesListFunc");
			} else {
				this.$root.$emit("danger", "Please input valid data");
			}
		},

		async getProductList() {
			const products = await productManagementService.getProductList();
			products.forEach(item => {
				this.productlist.push({
					value: item.product,
					text: item.product,
				});
			});
		},

		async getTadigList() {
			const products = await productManagementService.getNsimGTList();
			const uniqueTadigSet = new Set();

			products.forEach(item => {
				if (!uniqueTadigSet.has(item.tadig)) {
					uniqueTadigSet.add(item.tadig);
					this.tadiglist.push({
						value: item.tadig,
						text: item.tadig,
					});
				}
			});

			this.tadiglist.sort((a, b) => {
				return a.text.localeCompare(b.text);
			});
		},

		async getLocationList() {
			let arr = [];
			await productManagementService
				.getNsimLocations()
				.then(res => {
					// console.log(res)
					res.forEach(item => {
						if (item.location != "*" || item.location != "") {
							arr.push(item.location);
						}
					});
					this.locationList = arr;
				})
				.catch(err => {
					if (process.env.NODE_ENV === "development") {
						console.log(err);
					}
					this.$toast.error(err.message);
				});
		},
	},
};
</script>
